<template>
    <div>
        <div
            v-if="isThumbnail"
            class="w-full aspect-ratio-4/3 relative mb-3"
        >
            <div
                :style="{
                    'background-image': `url('${imgSrc}')`
                }"
                class="absolute inset-0 rounded bg-white bg-center bg-cover bg-grey-lightest h-full"
            />

            <div
                v-if="index !== null"
                class="p-2 mx:p-6 absolute top-0 right-0 leading-none"
            >
                <div class="text-sm font-semibold rounded-full px-2 py-1 text-grey-darker bg-white-85a">
                    {{ index + 1 }}
                </div>
            </div>
        </div>

        <div class="flex items-center">
            <with-truthiness
                v-slot="{
                    value: svg
                }"
                :object="{
                    'icon-check-circle': status === 'success',
                    'icon-close-circle': status === 'failed',
                    'icon-important-circle': status === 'error',
                    'icon-loading': ['uploading', 'queued'].includes(status),
                }"
            >
                <base-svg
                    :name="svg"
                    :key="svg"
                    :class="{
                        'fill-primary-green-dark fill-secondary-green-lighter': status === 'success',
                        'fill-primary-red-dark fill-secondary-red-lighter': ['failed', 'error'].includes(status),
                    }"
                    class="w-6 h-6 mr-3 flex-none"
                />
            </with-truthiness>

            <div class="flex-grow truncate mr-3">
                {{ name }}
            </div>

            <button
                type="button"
                class="w-6 h-6 flex-none"
                @click.prevent="$emit('remove')"
            >
                <base-svg
                    name="icon-close"
                    class="fill-primary-grey"
                />
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            isThumbnail: {
                type: Boolean,
                required: true
            },
            index: {
                type: Number,
                default: null
            },
            name: {
                type: String,
                required: true
            },
            imgSrc: {
                type: String,
                default: null
            },
            status: {
                type: String,
                required: true
            }
        }
    }
</script>
